'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { Reference, ReferenceSources } from '../references-records';
import { MAPPING } from './legacy-mapping';
import memoize from 'transmute/memoize';
import { Metrics } from '../../../../shared/Metrics';
import { ReportingLogger } from 'reporting-data/monitoring/reportingLogger';
const logLegacy = memoize((objectTypeId, propertyName) => {
  const reportingLogger = new ReportingLogger();
  reportingLogger.addAttribute('objectTypeId', objectTypeId);
  reportingLogger.addAttribute('propertyName', propertyName);
  reportingLogger.sendPageAction('legacyHydrationInSnowflake');
});
const defaultGetFallbackReference = id => Reference({
  id,
  label: id,
  source: ReferenceSources.LEGACY
});
export const getLegacyResolver = (objectTypeId, propertyName) => {
  const legacyResolver = MAPPING.getIn([objectTypeId, propertyName]);
  if (typeof legacyResolver !== 'function') {
    return undefined;
  }
  const getResolver = legacyOptions => (id, getFallbackReference) => {
    const legacyOption = legacyOptions.get(id);
    let reference;
    if (legacyOption) {
      reference = Reference({
        id,
        label: `${legacyOption.get('label')} (${id})`,
        source: ReferenceSources.LEGACY
      });
    } else {
      Metrics.counter('no_resolver', {
        type: 'legacy'
      }).increment();
      reference = getFallbackReference(id);
    }
    return Promise.resolve(reference);
  };
  logLegacy(objectTypeId, propertyName);
  return (ids, getFallbackReference = defaultGetFallbackReference) => {
    try {
      return legacyResolver(undefined, undefined, undefined, undefined, ids).then(legacyResult => legacyResult.get('value')).then(legacyOptions => {
        const resolver = getResolver(legacyOptions);
        const promises = ids.map(id => resolver(id, getFallbackReference));
        return Promise.all(promises).then(references => List(references));
      }).catch(() => {
        Metrics.counter('no_resolver', {
          type: 'legacy'
        }).increment();
        return ImmutableMap({
          key: undefined,
          value: ImmutableMap()
        });
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
};